import { chain, map } from 'fp-ts/lib/TaskEither';
import { pipe } from 'fp-ts/lib/function';
import {
  createAuthorizedDeleteRequest,
  createAuthorizedGetRequest,
  decode,
  fetchApi,
  setQuery,
} from '@/services/api';
import { resourceBulkDelete } from '@/services/api/resources/bulkDelete';
import { courseReportsListCodec, courseReportDetailCodec } from './codec';
import { CourseReportQuery, encodeCourseReportQuery } from './query';

const baseUrl = '/v2/trainings/course-reports';
const recordUrl = (id: number) => `${baseUrl}/${id}`;

export const listCourseReports = (query: CourseReportQuery) => pipe(
  baseUrl,
  createAuthorizedGetRequest,
  map(setQuery(encodeCourseReportQuery(query))),
  chain(fetchApi),
  chain(decode(courseReportsListCodec)),
);

export const removeCourseReport = (id: number) => pipe(
  id,
  recordUrl,
  createAuthorizedDeleteRequest,
  chain(fetchApi),
);

export const getCourseReport = (id: number) => pipe(
  id,
  recordUrl,
  createAuthorizedGetRequest,
  chain(fetchApi),
  chain(decode(courseReportDetailCodec)),
);

export const bulkDeleteCourseReports = (records: number[]) => resourceBulkDelete(records, baseUrl);
